import React from 'react';
import { Box, Button, Typography } from '@mui/material';

interface Subject {
  title: string;
  document: string;
}

interface MenuProps {
  subjects: Subject[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

export default function Menu({ subjects, selectedIndex, onSelect }: MenuProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '250px',
        borderRight: '1px solid',
        borderColor: 'divider',
        height: '100%',
        backgroundColor: 'background.paper',
        overflow: 'hidden',
        flexShrink: 0,
      }}
    >
      {/* Fixed Header */}
      <Box
        sx={{
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          flexShrink: 0,
        }}
      >
        <Typography variant="h6" component="h2" color="text.primary">
          Instructions
        </Typography>
      </Box>

      {/* Scrollable Button Container */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          overflow: 'auto',
          p: 2,
          flex: 1,
          height: '100%',
        }}
      >
        {subjects.map((subject, index) => (
          <Button
            key={subject.title}
            variant={selectedIndex === index ? 'contained' : 'outlined'}
            onClick={() => onSelect(index)}
            fullWidth
            sx={{
              justifyContent: 'flex-start',
              textAlign: 'left',
              minHeight: '48px',
              whiteSpace: 'normal',
              height: 'auto',
              color: selectedIndex === index ? 'primary.contrastText' : 'text.primary',
            }}
          >
            {subject.title}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
